import React from 'react';
import LocationPage from './LocationPage';

export const GoldCoastPage = () => (
  <LocationPage
    city="Gold Coast"
    state="QLD"
    suburb="Gold Coast"
    region="South-East Queensland"
    description="Find safe, affordable shared housing on the Gold Coast designed for Australian Age Pensioners. Live near beaches, world-class amenities and medical services — at 40–60% less rent than living alone."
    nearby={['Surfers Paradise', 'Robina', 'Broadbeach', 'Southport', 'Nerang', 'Coomera', 'Helensvale', 'Coolangatta', 'Mudgeeraba', 'Upper Coomera']}
  />
);

export const SunshineCoastPage = () => (
  <LocationPage
    city="Sunshine Coast"
    state="QLD"
    suburb="Sunshine Coast"
    region="South-East Queensland"
    description="Discover shared housing on the Sunshine Coast for Australian Age Pensioners. Enjoy beautiful beaches and a relaxed lifestyle while saving 40–60% on rent through vetted co-living."
    nearby={['Maroochydore', 'Caloundra', 'Noosa', 'Buderim', 'Coolum', 'Nambour', 'Kawana', 'Mooloolaba', 'Peregian', 'Sippy Downs']}
  />
);

export const SydneyPage = () => (
  <LocationPage
    city="Sydney"
    state="NSW"
    suburb="Sydney"
    region="Greater Sydney"
    description="Affordable shared housing in Sydney for Australian Age Pensioners. Stay in the city you love — close to family, hospitals and services — while reducing rent by up to 60% through vetted shared living."
    nearby={['Parramatta', 'Penrith', 'Blacktown', 'Liverpool', 'Campbelltown', 'Hornsby', 'Sutherland', 'Bankstown', 'Hurstville', 'Cronulla']}
  />
);

export const MelbournePage = () => (
  <LocationPage
    city="Melbourne"
    state="VIC"
    suburb="Melbourne"
    region="Greater Melbourne"
    description="Find shared housing in Melbourne for Australian Age Pensioners. Stay connected to Melbourne's world-class healthcare, transport and community — while paying up to 60% less rent through HSS."
    nearby={['Dandenong', 'Frankston', 'Werribee', 'Geelong', 'Craigieburn', 'Melton', 'Pakenham', 'Ringwood', 'Knox', 'Doncaster']}
  />
);

export const BrisbanePage = () => (
  <LocationPage
    city="Brisbane"
    state="QLD"
    suburb="Brisbane"
    region="Greater Brisbane"
    description="Affordable shared housing in Brisbane for Australian Age Pensioners. Stay close to family and Queensland's best healthcare facilities while reducing rent by 40–60% through vetted co-living."
    nearby={['Logan', 'Ipswich', 'Redcliffe', 'Carindale', 'Chermside', 'Springwood', 'Wynnum', 'Sandgate', 'Zillmere', 'Strathpine']}
  />
);
